/**
 *  // Extending CT.utils, jQuery and/or Underscore namespaces here for HOTELS only
 */
!function(module){
	//>>excludeStart("requireTmpl", pragmas.requireTmpl);
	if(window.define) define('hotels/hotel_utils',['libs/ct_store', 'hotelBackgroundSearch', 'ct_utils'], module)
	else
	//>>excludeEnd("requireTmpl");
		module(CT.Store, CT.hotelBackgroundSearch)
}(function(store, hotelBackgroundSearch){

	$.extend(true, CT.utils, {
		
		Nagger : (function(){

			var funcArray = [], initialize = false, _interval;

			//function _curry(fn) {  var args = Array.prototype.slice.apply(arguments); return fn.apply(undefined, args.slice(1)); }

			function _clear() {
				funcArray = [];
				clearInterval(_interval);
			}

			function _curry() {

				var args = Array.prototype.slice.call(arguments);
				args = args[0];
				fn = args[0];
				args = Array.prototype.slice.call(args);
				args = args.slice(1);
				return function() {
					return fn.apply(window, args.concat(
						Array.prototype.slice.call(arguments)));

				};
			};


			function _init() {
				_interval = setInterval(function() {
					var len = funcArray.length;
					while (len--) {
						//console.log("Nag!");
						if (funcArray[len]()) {
							funcArray.pop();
						}
					}
				}, 20);
			}



			function _nag(){
			//	console.log("nag nag nag");
				var cFunc = _curry(arguments);
				funcArray.push(cFunc);
				cFunc();
				if(!initialize){
					_init();
					initialize = true;
				}
			};



			return { nag : _nag, clear: _clear };

		})(),
		
		/** ======================= BEGINNING of HELPER FUNCTIONS ======================= **/
		helperFunctions : {
			getBrowserName: function(){
				var userAgent = window.navigator.userAgent;
				if(userAgent.indexOf("Trident") > -1){
					return "IE";
				} else {
					return "Other";
				}
			},
			getAllAvailFilterLists: function () {
				//TODO:: Locality Filter :: Remove localities
				return ["taStarRating","starFilter","payAtHotel","freeCancellation","chain","amenity","propertyType","deals","pahCCRequired", "op", "price","area","sd", "list","lowRate", "view","sort_order","sort", "sort_order","showFewFilter", "dest_code", "localities", "tagsFilter", "lolfilter"];
			},
			/*
			 * @DESC : returns hotel modal window (iframe) url
			 */
			getHotelModalUrl: function(hotelId) {
				var rrArr = [], baseUrl = '/hotels/api/info/' + hotelId + '/modal',
				hotelJson = CT.masterJson.getHotel(hotelId);

				if(hotelJson.priceInfo) {
					_.forEach(hotelJson.priceInfo.rms, function(eachRoom) {
						rrArr.push(eachRoom.rmtc);
					});
				}

				if(rrArr.length > 0)
					baseUrl += '?&rr=' + rrArr.join('&rr=');
				else
					baseUrl += '?';

				if(CT.app == 'hotel')
					baseUrl += '&tux=1';

				return baseUrl;

			},

			/*
			 * @DESC : Ajax call for logging,used as of now for pinpoint
			 */
			dashBoardLogging : function(paramObj) {
				var url="/hotels/pinpoint/log";
				var params = _.serialize(paramObj)
				$.ajax({
					url: url,
					type: 'POST',
					data: params,
					success: function (data) {
    					
    				},
    				error: function(){
    					
    				}
				});

			},
			
			 getDistanceFromLatLonInKm : function(lat1, lon1, lat2, lon2) {
					var R = 6371;
					// Radius of the earth in km

					var deg2rad = function(deg) {
						return deg * (Math.PI / 180)
					}     
					var dLat = deg2rad(lat2 - lat1);
					// deg2rad below
					var dLon = deg2rad(lon2 - lon1);
					var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
					var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
					// Distance in km
					var d=R*c;
					return d;
				},



			/*
			 * @DESC : returns markup of hotel amenities
			 */
			getHotelAmenities: function(am, roomAmenities,shwName) {
				var amenitiesTagAttrs, amenitys, amIcons;

				roomAmenities = roomAmenities || false;
				amenitiesTagAttrs = roomAmenities ? CT.settings.general.roomAmenitiesMap : (window.amenitiesMap ? window.amenitiesMap : CT.settings.general.amenitiesMap);

				amenitys = (roomAmenities ? "0000000000000" : "000000000000000000") + parseInt(am, 16).toString(2);
				amenitys = amenitys.substring(amenitys.length - (roomAmenities ? 12 : 17));
				if(!roomAmenities){
					amenitys = amenitys.split("").reverse().join("");					
				}
				amIcons = {};
				amIcons.activeAmenities = [];
				amIcons.shwName = shwName ? true:false;
				for (var j = 0; j < amenitys.length; j++) {
					var _am;
					if($.browser.msie) _am = amenitys.split('')[j];
					else _am = amenitys[j];
					if (_am == "1") {
						amIcons[amenitiesTagAttrs[j]["class"]] = true;
						amIcons.activeAmenities.push(amenitiesTagAttrs[j]["title"]);
					}
				}
				return amIcons;
			},




			/*
			 * @desc : general function to calculate discount percentage
			 */
			calDiscountPercent: function(discAmt, discPrice) {
				return (discAmt / (discPrice + discAmt) * 100).toFixed(3);
			},







			/*
			 * @DESC : this function truncates text inside an element
			 * @PARAM : anchorAttrs - this object will be added to more/less anchor tag
			 * @PARAM : callback - function to be called upon more/less click
			 */
			truncateText: function($element, charsLimit, anchorAttrs, callback) {
				var originalText = $element.text().trim(), attrString = '';

				charsLimit = charsLimit ? Int(charsLimit) : 200;

				callback = callback || function($thisTag) {
					if($thisTag.attr('data-type') == 'more') {
						$thisTag.siblings('.originalContent').show();
						$thisTag.siblings('.displayText').hide();
						$thisTag.attr('data-type', 'less').html(CT.messages.hotel.Less);
					} else {
						$thisTag.siblings('.originalContent').hide();
						$thisTag.siblings('.displayText').show();
						$thisTag.attr('data-type', 'more').html(CT.messages.hotel.More);
					}
				};

				if(anchorAttrs) {
					_.forEach(anchorAttrs, function(name, index) {
						attrString += index + '=' + name + ' ';
					});
				}

				if(originalText.length > charsLimit) {
					originalContent = $element.html();
					displayText = originalText.substring(0, charsLimit);
					$element.html('<div class="originalContent" style="display:none">' + originalContent + '</div>');
					$element.append('<span class="displayText">' + displayText + ' ... </span>');
					$element.append('<a href="#" class="truncateToggle weak" ' + attrString + ' data-type="more">'+CT.messages.hotel.More+ '</a>');

					$element.find('.truncateToggle').click(function(e) {
						callback($(e.target));
					});
				}
			},

			removeCamaInString: function(text){
				var strVal = text;
				var lastChar = strVal.slice(-1);
				  if (lastChar == ',') {
					  	strVal = strVal.slice(0, -1);
					 }
				return strVal;
			},

			updateHideShowMessage : function(e) {
				if(e) {
					var $element = $(e.currentTarget);

					//adding the element container to hide always in the current tab
					if((tmp = $element.attr('data-hidemessage'))) {
						CT.cache[CT.settings.currentTab].hideMessages[tmp] = true;
						store('hideMessages').set(tmp, true);
					}
					else if((tmp = $element.attr('data-showmessage'))) {
						CT.cache[CT.settings.currentTab].hideMessages[tmp] = false;
						store('hideMessages').set(tmp, false);
					}
				}
			},
			
			
			/**
			 * return room rate mark up for villas. returns tr
			 */
			getVillasRmsMarkup: function (rmsArr,modalFlag,propertyType){
				rmsArr[0].sub[0].tot = CT.utils.formatForCurrency(rmsArr[0].tot);
				rmsArr[0].sub[0].bkBtn = true;
				rmsArr[0].sub[0].rmtc = rmsArr[0].rmtc
				rmsArr[0].sub[0].rtc = rmsArr[0].rtc
				rmsArr[0].sub[0].rowspan = rmsArr[0].sub.length;
				if(modalFlag == undefined){ //it means request coming from hotel modal
					_.map(rmsArr[0].sub,function (elem,i){
						elem.isModal = true;
					});	
				}else{
					_.map(rmsArr[0].sub,function (elem,i){
						elem.isModal = false;
					});
					rmsArr[0].sub[0].pt = propertyType ? propertyType : "property";
				}
				return CT.to_html('TripVillasTpl', {"sub" : modalFlag == undefined ? rmsArr[0].sub : rmsArr[0].sub[0]});
			},
			
			createSliders : function (){
				if(CT.cache[CT.settings.currentTab].sliderImgsloaded == false) return false;
				var cache = CT.cache[CT.settings.currentTab].searchParams.processed;
				var placesUri = this.getImageUrl(cache.city, window.hotelBaseLink + "/places/hotels",200, 200);
					htImgs = CT.masterJson.get().htImgs,
					$currentTab = $("#ResultContainer_" +CT.settings.currentTab).find("ul.listView"),
					$galleryTag = "",
					attrObj = {fullscreen : {enabled : false, nativeFS : false},controlNavigation : 'none',loop : false,imageScalePadding : 0,autoCenter : true,imageAlignCenter : false,imageScaleMode:"fill",numImagesToPreload : 4,arrowsNavAutohide : true,arrowsNavHideOnTouch : true,keyboardNavEnabled : true, transitionSpeed:300}
				var i = 0;
				function replaceImage(id){
						var imgs = id.indexOf("ABNB") == -1 ? htImgs[id]:[],
						imgArray = [],oImg = CT.masterJson.getHotel(id).replacedimg;
						
				//	var uspText = CT.masterJson.getHotel(id) && CT.masterJson.getHotel(id).usp ? CT.masterJson.getHotel(id).usp : "Default Text";

					if(id){
						for(var k in imgs){
							if(imgs.hasOwnProperty(k)){
								var _tmpIm, _tmpImg;
								var _tmpImReplaced = imgs[k];
								if(!CT.utils.helperFunctions.isCloudinaryEnabled(cache.city)){
									_tmpIm = imgs[k].split("_w.");
									_tmpImReplaced = _tmpIm[0] +"_200x200."+_tmpIm[1].toLowerCase();
									//_tmpImReplaced = _tmpIm[0] +"_270x185."+_tmpIm[1].toLowerCase();
									//console.log('_tmpImReplaced', _tmpImReplaced)
								}
								var _im = _tmpImReplaced.split("images/")[1];
								if(_im && _im.indexOf(oImg) >= 0){
									//arr1.push(_im);
								}else{
									if(CT.cache[CT.settings.currentTab].searchParams.all.country == "IN"){
										_tmpImg = _tmpImReplaced;
									}else{
										_tmpImg = imgs[k];
									}
								}
								if(_tmpImg){
									imgArray.push({"imgUrl": id.indexOf("ABNB") == -1 ?placesUri + _tmpImg : _tmpImg, "photoCount": 0})
								}
							}
						}
						//$currentTab.find("#"+id+" .photoFrame").html(CT.to_html('RoyalSliderAppendImageTpl', {imgArray:imgArray,photoCount:imgArray.length +" Photos"}));
						//$currentTab.find('#'+id+' .royalSlider').royalSlider(attrObj).css('visibility', 'visible');
						var imgArrLength = imgArray.length + 1;
						if($currentTab.find('#'+id+' .royalSlider').data('royalSlider') && $currentTab.find('#'+id+' .royalSlider').data('royalSlider').numSlides != imgArrLength){
							for(var z=0;z<imgArray.length;z++){
								$currentTab.find('#'+id+' .royalSlider').data('royalSlider').appendSlide(CT.to_html('RoyalSliderAppendImageTpl', {imgArray:imgArray[z]}));
							}	
						}
						//$currentTab.find('#'+id).attr("data-imgAppended","true");
						if(window.abTestVal == "a"){
							var tnImgArr = [];
							var renderImgJson = {};
							var imgHtml;
							renderImgJson.url = []
							if(imgs && imgs.length > 0){
								var tmpImgArr = _.first(imgs,6);
								for(var k=0;k<tmpImgArr.length;k++){
									var tmpImgUrl = tmpImgArr[k];
									if(!this.isCloudinaryEnabled(cache.city)){
										tmpImgUrl = tmpImgArr[k].replace("_w.","_tn.");
									}
									renderImgJson.url.push({
										src : placesUri + tmpImgUrl,
										photoIndex: k + 1
									});
								}
								imgHtml = CT.to_html('HotelImgThumbTpl', renderImgJson);
								$currentTab.find('#'+id+' .additionalInfo').html(imgHtml);
								$currentTab.find('#'+id+' .additionalInfo').find('img').setLoad(CT.utils.imgAdjust);	
							}	
						}
						//$currentTab.find("#"+id+" .humanDescription").html("<p>"+uspText+"</p>");
					}
				}
				
				$currentTab.children().each(function(){
					if(this.id != "" && !$currentTab.find("#"+this.id).attr("data-imgAppended") && $(this).hasClass("listItem")){
						replaceImage(this.id);
						$currentTab.find("#"+this.id).attr("data-imgAppended", 'true');
					}
					/*if((CT.infScrollLast > 20) && (i > CT.infScrollLast) && this.id != ""){
						replaceImage(this.id);
					}
					if(CT.infScrollLast == 20 && this.id != ""){
						replaceImage(this.id);
					}*/
					//i++;
				})
			},
			
			getCityImages : function (){
				var params = _.deserialize(window.location.search.replace('?',""));
				var that = this;
				var mJson = CT.masterJson.get();
				var cache = CT.cache["1_1"].searchParams.processed;
				CT.cache[CT.settings.currentTab].sliderImgsloaded = false;
				if(CT.subProd != "airBnb"){
					if(hotelBackgroundSearch.get("images")){
						CT.cache[CT.settings.currentTab].sliderImgsloaded = true;
						//changing key value pair to id and images path
						var response = JSON.parse(hotelBackgroundSearch.get("images"));
						var newJson = {};
						_.each(response.r, function(val,i){
							if(val.id){
								var arr = [];
								_.each(val.im,function (_val,j){
									arr.push(_val);
								})
								newJson[val.id] = arr;
							}
						});
						mJson["htImgs"] = newJson;
						that.createSliders();
					} else if($("#Tags")[0] && $("#Tags")[0].cityImagesBgSearch){
						var cityImagesBgSearch = $("#Tags")[0].cityImagesBgSearch;
						 
						cityImagesBgSearch.get({"city":cache.city,"state":cache.state,"country":cache.country}, function(response){
							if(response && response.data){
								CT.cache[CT.settings.currentTab].sliderImgsloaded = true;
								mJson["htImgs"] = 	response.data;
								that.createSliders();
							}
						});
					}else{
						$.ajax({
							type: "GET",
							url: "/hotels/jsonservice/city-images",
							//url: "http://dev.cleartrip.com/hotelstatic/json/imagesStatic.json"
							data: {"city":cache.city,"state":cache.state,"country":cache.country}
						}).done(function(response) {
							if ( typeof response == "string") {
								try {
									response = JSON.parse(response);
								} catch(e) {}
							}
							//changing key value pair to id and images path
							var newJson = {};
							_.each(response.r, function(val,i){
								if(val.id){
									var arr = [];
									_.each(val.im,function (_val,j){
										arr.push(_val);
									})
									/*if(val.usp && val.usp != ""){
										CT.masterJson.getHotel(val.id)["usp"] = val.usp;
									}else{
										CT.masterJson.getHotel(val.id)["usp"] = CT.settings[CT.app].twoColUspMap[val.tas] ? CT.settings[CT.app].twoColUspMap[val.tas].text : "";
									}*/
									newJson[val.id] = arr;
									CT.cache[CT.settings.currentTab].sliderImgsloaded = true;
								}
								
							});
							mJson["htImgs"] = 	newJson;
							that.createSliders();
						});
					}
					
					
				}else{
					CT.cache[CT.settings.currentTab].sliderImgsloaded = true;
					mJson["htImgs"] = {};
					that.createSliders();
				}
				
			},
			//TODO: code-logic to be relooked 
			prefetchCityImages : function(field,params){
				
				field.hotelContentBgSearch.get(params,function(content){
					if(content.data){
						var hotelContentBgSearchData = content.data; 
						field.cityImagesBgSearch.get(params,function(content){
							if(content.data){
								var cityImagesBgSearchData = content.data;
								var baseurl = window.hotelBaseLink+"/places/hotels";
								
								if(hotelContentBgSearchData && cityImagesBgSearchData){
									for(var i=0;i<=4;i++){
										if(hotelContentBgSearchData[i] && cityImagesBgSearchData[hotelContentBgSearchData[i].id][0]){
											var htImg = baseurl + cityImagesBgSearchData[hotelContentBgSearchData[i].id][0];
											$(body).append('<link rel="prefetch" href="'+htImg + '" />');
										}
											
									}
								}
							}
							
						});
					}
				});
				
				
			},
			
			
			/*
			 * @DESC : Wrapper to change the category of the events
			 * 
			 */
			
			trackGAEventWrapper : function(category,action,label,timeout){
				var tmpCat = category.split("_");
				if(tmpCat[1] == "TS" && CT.subProd && CT.subProd == "wg"){
					category = "Hotels_GS"
				}else if(tmpCat[1] == "TR" && CT.subProd && CT.subProd == "wg"){
					category = "Hotels_GR"
				}
				CT.utils.helperFunctions.trackGAEvent(category,action,label,timeout);
				
			},

			openHotelModalWindow : function(hotelId,tagHash){
				
		   		var baseUrl = '', windowWidth = '90%', tmp, hotel_rank = '';
		   		var countryCode =  window.countryCode;
		   		var currentSlideId = 0, royalSlider = $('#' + hotelId + ' .royalSlider').data('royalSlider');
			 	tagHash = tagHash || '';
			 
			 	if(tagHash === '#photos' && royalSlider) {
			 		tagHash = tagHash + '#' + royalSlider.currSlide.id;
			 	}
		   	 	baseUrl = CT.utils.helperFunctions.getHotelModalUrl(hotelId);
			 	//baseUrl = "/hotels/info/1784199/modal?&rr=&tux=1";
                if(hotelId.indexOf("ABNB")>=0)
                	baseUrl += "&abnb=true";
				tmp = CT.cache[CT.settings.currentTab].searchParams.all;
				if(tmp.utm_source && tmp.utm_source == 'tripadvisor')
					windowWidth = '960';
				hotel_rank = CT.masterJson.getHotel(hotelId).p;
				hotel_rank = !hotel_rank ? '' : hotel_rank;
				//CT.utils.showModalDialog(baseUrl  + '&rank=' + hotel_rank + '&tux=1' + tagHash, windowWidth,'550',true,false,function(yPos) { window.scrollTo(0, yPos); },undefined,undefined,undefined,true);
				var useFullScaleModalWindow = true;
				CT.utils.showModalDialog(baseUrl  + '&rank=' + hotel_rank + '&tux=1' + tagHash, windowWidth,'550',true,false,function(yPos) { window.scrollTo(0, yPos); },undefined,undefined,undefined,true, undefined, undefined, useFullScaleModalWindow);
				// fire hotel remarketing pixel
				var params = CT.cache[CT.settings.currentTab].searchParams.all;
				var _cd = params.chk_in.split("/");
				var _cout = params.chk_out.split("/");
				// fire nanigan pixel.
				CT.utils.helperFunctions.trackNanigan({type: 'user', name: 'HotelSearch', HotelRN: window._roomnights, HotelCity: params.city, HotelPassA: params.adults, HotelPassC: params.childs, HotelCheckin: params.chk_in, sku: hotelId});
		   },
			openHotelModalV2: function(hotelId , searchParams,tagHash,slugId){
				slugId = slugId || "";
				var hotelDetailURL = "/hotels/details/";
				if(slugId !== ""){
					hotelDetailURL += slugId
				}
				else{
					hotelDetailURL += hotelId
				}
				searchedHotelIds=hotelId;
				   var searchParamObj, searchParamAll,url,compId = "";
				   var hotelObj = searchParams == undefined ? CT.masterJson.getHotel(hotelId) : false;
				   var areaSearch=hotelObj.areaSearch?true:false;
				   var poiSearch=hotelObj.poiSearch?true:false;
				   var paramsInUrl;
				   if(hotelObj.isgoogleSearch|| hotelObj.op){
				     paramsInUrl=hotelObj.locId?"&localityId="+hotelObj.locId:'';
				     if(!paramsInUrl || paramsInUrl==''){
				   	 	if(hotelObj.areaName && hotelObj.areaLat && hotelObj.areaLng)
				   	 		paramsInUrl="&areaName="+hotelObj.areaName+"&lat="+hotelObj.areaLat+"&lng="+hotelObj.areaLng;
				   	 }
				   }
				   if(areaSearch)
				   	 paramsInUrl=hotelObj.locId?"&localityId="+hotelObj.locId:'';
				   if(poiSearch)
				   	 paramsInUrl=hotelObj.locId?"&localityId="+hotelObj.locId:'';
				   searchParamObj = searchParams == undefined ? CT.cache[CT.settings.currentTab].modifiedSearchObj : searchParams;
				   searchParamAll = decodeURIComponent(_.serialize(searchParamObj));
				   tagHash = tagHash == "#highlights" ? "#" : tagHash;
				   if(window.companyId) {
					   compId =  window.companyId;
				    }
				  
				   if (hotelObj == false){
					   url = (window.CT.langUrlPrefix? window.CT.langUrlPrefix:"") + hotelDetailURL + "?" + searchParamAll +"&compId="+ compId + tagHash;
				   }else{
				   		var stpType = "";
				   		if(window.enableNewStpFlow){
				   			if(hotelObj.priceInfo && hotelObj.priceInfo.rms){
					   			var firstRms = hotelObj.priceInfo.rms[0];
					   			if(firstRms.stpd && firstRms.stpd.stp){
					   				stpType = "calculated";
					   			}else if(firstRms.d != undefined && firstRms.d > 0){
					   				stpType = "chmm";
					   			}else{
					   				stpType = "none";
					   			}
					   		}else{
					   			stpType = "none";
					   		}
				   		}else{
				   			stpType = "";
						}
						var metaRef = (new URL(document.location)).searchParams.get("meta_ref") || null;
						if( metaRef && metaRef.split('|')[0] && metaRef.split('|')[1]){
							url = (window.CT.langUrlPrefix? window.CT.langUrlPrefix:"") + hotelDetailURL + "?" + searchParamAll +(paramsInUrl?paramsInUrl:'')+"&compId="+ compId +'&meta_ref='+metaRef.split('|')[0]+'|'+ metaRef.split('|')[1]+"&fr="+hotelObj.p+"&ur="+($("#"+hotelId).index() + 1)+"&urt="+$("#ResultContainer_"+CT.settings.currentTab).find(".sorters").find(".current").attr("data-sort") + (stpType ? ("&stp="+stpType) : "" ) + ( CT.cache.tabsMap[CT.settings.currentTab].appliedFiltersParmas ? '&'+CT.cache.tabsMap[CT.settings.currentTab].appliedFiltersParmas  : '' )+ tagHash; 
						} else{
							url = (window.CT.langUrlPrefix? window.CT.langUrlPrefix:"") + hotelDetailURL + "?" + searchParamAll +(paramsInUrl?paramsInUrl:'')+"&compId="+ compId + "&fr="+hotelObj.p+"&ur="+($("#"+hotelId).index() + 1)+"&urt="+$("#ResultContainer_"+CT.settings.currentTab).find(".sorters").find(".current").attr("data-sort") + (stpType ? ("&stp="+stpType) : "" ) + ( CT.cache.tabsMap[CT.settings.currentTab].appliedFiltersParmas ? '&'+CT.cache.tabsMap[CT.settings.currentTab].appliedFiltersParmas  : '' )+ tagHash; 
						}
						
					    //url = "/hotels/details/" + hotelId + "?" + searchParamAll + "&fr="+hotelObj.p + tagHash; 

				   }
				   return url;
			   },
		   addLocationDetails:function(hotelObj,locInfo){ //helper function to add areaName and Lat-Lng to the hotel Obj//Part of Location 1.0
		   		hotelObj.areaName=locInfo.area;
		   		hotelObj.areaLat=locInfo.lat;
		   		hotelObj.areaLng=locInfo.lng;
		   		delete hotelObj.locId
		   },	   
		   checkCityId: function(cityId,urlData){
			   return window.hotelModalV2;
		   },
		   getSelectedCountry : function(){
	            var paramsHash = CT.cache[CT.settings.currentTab] ? CT.cache[CT.settings.currentTab].searchParams.all : {};
	            if(paramsHash.country){
	                return paramsHash.country.toLowerCase();
	            }
	            return false;
	        },
	        isDomesticHotel : function(){
	            var country = this.getSelectedCountry();
	            if(country) {
	                return country === 'in';
	            }
	            return false;
	        },
		   basicSearchParams: function(searchParams){
			   var srchCritObj = searchParams;
			   var modifiedSearchObj = {},tmp = "";
			   if(srchCritObj.chk_in != ""){
				   modifiedSearchObj.c = moment(srchCritObj.chk_in,"DD/MM/YYYY").format("DDMMYY")+"|"+moment(srchCritObj.chk_out,"DD/MM/YYYY").format("DDMMYY")
			   }else{
				   modifiedSearchObj.c = "" 
			   }
			   for(var i=1;i<=parseInt(srchCritObj.num_rooms);i++){
				   var sep = i != parseInt(srchCritObj.num_rooms) ?"|":""
				   if(srchCritObj["ca"+i]){
					   tmp += srchCritObj["adults"+i]+","+srchCritObj["children"+i]+"-"+srchCritObj["ca"+i].toString()+ sep;
				   }else{
					   tmp += srchCritObj["adults"+i]+","+srchCritObj["children"+i]+ sep ;
				   }
			   }
			   modifiedSearchObj.r = tmp;
			   if(srchCritObj.utm_source || srchCritObj.hotelNameSearch){
				   modifiedSearchObj.shwb = true;
			   }
			 return modifiedSearchObj;
		   },
		   getEnvironment: function() {
				var host = window.location.hostname.split('.')[0];
				var settings = 'development';
				if(host == 'beta' || host == 'www'){
					settings = 'production';
				}else if(host == 'qa2'){
					settings = 'qa';
				}
				return settings;
		   },
		   isCloudinaryEnabled: function(city){
			return window.cloudinaryEnabled && window.cloudinaryCityList.indexOf(city) > -1;
		   },
		   getImageUrl: function(city, baseUrl, width, height) {
				if(CT.utils.helperFunctions.isCloudinaryEnabled(city)){
					var strWidthHeight = width ? "w_"+ width + ",h_"+ height + ",": "";
					var apiName = "upload";
					if(this.getEnvironment() === "qa"){
						if(baseUrl.indexOf('/4dea/') != -1) {
							apiName = "fetch";
							baseUrl = baseUrl.indexOf('https:') === -1 ? "https:" + baseUrl : baseUrl;
						} else {
							baseUrl = "hotels_qa/places/hotels";						
						}
					} else {
						if(baseUrl.indexOf('/4dea/') != -1){
							apiName = "fetch";
							baseUrl = baseUrl.indexOf('https:') === -1 ? "https:" + baseUrl : baseUrl;
						} else {
							baseUrl = "hotels/places/hotels"; 					
						}
					}
			   		return "https://fastui.cltpstatic.com/image/"+ apiName +"/" + strWidthHeight + "f_auto,e_sharpen:80,q_100,c_fill/"+ baseUrl;				
				}
				//baseUrl = baseUrl.replace('qa2', 'ui');
				baseUrl = 'https://fastui.cltpstatic.com/image/upload/hotels/places/hotels'+ (window.location.host.startsWith("qa2") ? '_qa' : '')
				// baseUrl = baseUrl.replace(
				// 	'ui.cltpstatic.com',
				// 	(
				// 		'fastui.cltpstatic.com/image/upload/hotels'
				// 		+ (window.location.host.startsWith("qa2") ? '_qa' : '')
				// 	)
				// );
				return baseUrl;
		   }

		},
		/** ======================= END of HELPER FUNCTIONS ======================= **/
		/**
		 *  ===================================================================================================================
		 * ====================================================================================================================
		 */



		shortlists: {
			add: function(shortlistId, hotel, searchCriteria) {
				var shortlistStore = CT.Store("shortlistsStore", "hotel");
				var shortlists = shortlistStore.get("shortlists", "hotel") || {};
				if(!shortlists[shortlistId]){
					shortlists[shortlistId] = {};
					shortlists[shortlistId].hotels = {};
				}
				shortlists[shortlistId].hotels[hotel.id] = hotel;
				shortlists[shortlistId].searchCriteria = searchCriteria;
				shortlistStore.set("shortlists", shortlists, null, "hotel");
			},
			remove: function(shortlistId, hotelId) {
				var shortlistStore = CT.Store("shortlistsStore");
				var shortlists = shortlistStore.get("shortlists", "hotel");
				delete shortlists[shortlistId].hotels[hotelId];
				shortlistStore.set("shortlists", shortlists, null, "hotel");
			},
			getAllHotels: function(shortlistId){
				var shortlists = CT.Store("shortlistsStore").get("shortlists", "hotel");
				if(shortlists && shortlists[shortlistId]){
					return  Object.values(shortlists[shortlistId].hotels);
				} 
				return [];				
			},
			getAllHotelIds: function(shortlistId){
				var shortlists = CT.Store("shortlistsStore").get("shortlists", "hotel");
				if(shortlists && shortlists[shortlistId]){
					return Object.keys(shortlists[shortlistId].hotels);
				} 
				return [];
			},
			getSearchCriteria: function(shortlistId){
				var shortlists = CT.Store("shortlistsStore").get("shortlists", "hotel");
				if(shortlists && shortlists[shortlistId]){
					return shortlists[shortlistId].searchCriteria;
				} 
				return [];
			},
			getAllShortlist: function(){
				return CT.Store("shortlistsStore").get("shortlists", "hotel");
			},
			isHotelShortlisted: function(hotelId){
				var shortlists = CT.Store("shortlistsStore").get("shortlists", "hotel");
				if(shortlists && shortlists[shortlistId]){
					var hotelIds = Object.keys(shortlists[shortlistId].hotels);
					return hotelIds.indexOf(hotelId) > -1;
				}
				return false;
			},
			clearAll: function(){	
				CT.Store("shortlistsStore").remove("shortlists", "hotel");
			},
			sync: function(city){
				var worker = window.worker || new Worker('/javascripts/hotels/webWorker.js');
				var isLoggedIn = CT.utils.readCTAuthCookie();
				if(isLoggedIn){
					var shortlists = this.getAllShortlist();
					if(shortlists){	
						//Handle message from web worker				
						worker.addEventListener('message', function(e) {
							if(e.data.done){
								CT.utils.shortlists.clearAll();
								worker.terminate();
								CT.fire('updateShortlistId', [{
									shortlistId: e.data.shortlistId
								}]);
							}
						}, false);

						// Post message to web worker to start sync with DB
						worker.postMessage(shortlists);	
					}
				}
			}
		},
		modifySearch:{

			"open":function($arrow,$link){

				if(!CT.cache.els["$resultContainer"+ CT.settings.currentTab]){
					CT.cache.els["$resultContainer"+ CT.settings.currentTab] = $("#ResultContainer_"+CT.settings.currentTab);
				}


				var $homeCenter = CT.cache.els.$homeCenter,
					$resultContainer = CT.cache.els["$resultContainer"+ CT.settings.currentTab],
					$homeSection = CT.cache.els.$homeSection,
					$resultSection = CT.cache.els.$resultSection;

				if(!$arrow){
					$arrow = $resultContainer.find("#modifySearchLink").find("i");
				}
				if(!$link){
					$link = $arrow.parent();
				}

				$link.parent().addClass("current");
				$arrow.removeClass("rArrow").addClass("dArrow white");
				$homeSection.show();
				$homeSection.addClass("modifySearch");
				$resultSection.addClass("modifySearch");

				if($homeCenter.css("min-height")){
					$homeCenter.attr("backup-min-height",$homeCenter.css("min-height")).css("min-height","");
				}

				$homeCenter.css("height",$homeCenter.height());
				setTimeout(function(){
					$homeCenter.css("-webkit-transition","none");
					setTimeout(function(){
						$homeCenter.css("height","");
						setTimeout(function(){
							$homeCenter.css("-webkit-transition","");
						},100);
					},100);
				},500);

				$resultContainer.find("div.miniCalendar").addClass("mediumCalendar").removeClass("miniCalendar");
				$resultContainer.find(".viewSwitcher, .quickStopFilter, .badgeFilter .toolBarControls").fadeOut("fast");
                $resultContainer.find(".searchWidgetRow").removeClass("stickySearchWidgetRow");
				$resultContainer.find(".secondaryBar").removeClass("stickySecondaryBar");
			},

			"close":function($arrow,$link){

				if(!CT.cache.els["$resultContainer"+ CT.settings.currentTab]){
					CT.cache.els["$resultContainer"+ CT.settings.currentTab] = $("#ResultContainer_"+CT.settings.currentTab);
				}


				var $homeCenter = CT.cache.els.$homeCenter,
					$resultContainer = CT.cache.els["$resultContainer"+ CT.settings.currentTab],
					$homeSection = CT.cache.els.$homeSection,
					$resultSection = CT.cache.els.$resultSection;

				if(!$arrow){
					$arrow = $resultContainer.find("#modifySearchLink").find("i");
				}
				if(!$link){
					$link = $arrow.parent();
				}

				$link.parent().removeClass("current");
				$arrow.removeClass("dArrow white").addClass("rArrow");

				if($homeSection.hasClass("modifySearch")){
					$homeSection.hide();
					$homeSection.removeClass("modifySearch");
					$resultSection.removeClass("modifySearch");					
				}

				if($homeCenter.attr("backup-min-height")){
					$homeCenter.css("min-height",$homeCenter.attr("backup-min-height")).removeAttr("backup-min-height");
				}

				$resultContainer.find("div.mediumCalendar").addClass("miniCalendar").removeClass("mediumCalendar");
				$resultContainer.find(".viewSwitcher, .quickStopFilter, .badgeFilter .toolBarControls").fadeIn("fast");
				
			},


			openLabel:function(data){

				var displayData = {};

				displayData = {
					city: data.city?data.city:data.from,

					nights: data.num_nights?("("+data.num_nights+")"):"",

					isDateless: !(data.chk_in && data.chk_out),

					checkin : data.checkInDate,

					checkout: data.checkOutDate,

					rooms: data.num_rooms,

					adults: data.adults,

					children: data.childs || "",
					
					isMobile: window.isMobileUA
				}

				if(CT.subProd == "wg"){
					displayData.city = CT.messages.hotel.GatewaysFrom + displayData.city;
				}

				// alter DOM
				var $ctCenter = $("#GlobalNav .ctCenter");
				$ctCenter.find(".feedbackLink").hide();
				if($ctCenter.find(".searchSummary").length < 1){
					$ctCenter.append("<div class='searchSummary'></div>");
				}

				$ctCenter.find(".searchSummary").show().html(CT.to_html('SearchHeaderTemplate', displayData));
				$ctCenter.parent().show();
				//$ctCenter.html(CT.to_html('SearchHeaderTemplate', displayData));
				$("body").scrollTop(0);
			},
			closeLabel:function(){
				var $ctCenter = $("#GlobalNav .ctCenter");
				$ctCenter.find(".feedbackLink").show();
				$ctCenter.find(".searchSummary").hide();
			}
		},



		imgAdjust : function(applyOffset) {
			var $img = $(this);
			var $imgParent = $img.parent();

			if ($img.attr("src") == "" || $img.css("visibility") == "visible")
				return false;

			if ($imgParent.hasClass("loader")) {
				$imgParent.removeClass("loader spinnerSmall spinnerMedium");
			}
			//$imgParent.css("position", "relative");

			$img.css("position", "relative");





			//if(applyOffset === undefined || applyOffset === false){
				if ($img.width() <= $img.height()) {
					// portrait or square
					//$img.css('width', "100%");
					// ie fix
					if ($img.height() > $imgParent.height()) {
						var top = "-" + (($img.height() - $imgParent.height()) / 2) + "px";
						$img.css("top", top);
						//$img.css("height", "100%");
					}else{
						var top = "+" + (($img.height() - $imgParent.height()) / 2) + "px";
						$img.css("top", top);
					}
					if ($img.width() < $imgParent.width()) {
						var left = ($imgParent.width() - $img.width()) / 2 + "px";
						$img.css("left", left);
					}else{
						$img.css('width', "100%");
					}

				} else {// landscape

					// ie fix
					/*if($img.height() > $imgParent.height()){
						$img.css("height", "auto");
					}else{
						$img.css('height', "100%");
					}*/
					if ($img.width() > $imgParent.width()) {
						$img.css("width", "100%");
						if($img.height() > $imgParent.height()){
							var top = "-" + (($img.height() - $imgParent.height()) / 2) + "px";
							$img.css("top", top);
						}else{
							var top = (($img.height() - $imgParent.height()) / 2) + "px";
							$img.css("top", top);
						}
					}else{
						var left = ($imgParent.width() - $img.width()) / 2 + "px";
						$img.css("left", left);
						if($img.height() > $imgParent.height()){
							var top = "-" + (($img.height() - $imgParent.height()) / 2) + "px";
							$img.css("top", top);
							$img.css("height", "auto");
						}else{
							var top = (($img.height() - $imgParent.height()) / 2) + "px";
							$img.css("top", top);
							$img.css('height', "100%");
						}

					}
					/*if ($img.width() > $imgParent.width()) {
						var left = ($imgParent.width() - $img.width()) / 2 + "px";
						$img.css("left", left);
					}else{
						$img.css("width", "100%");
						//	$img.css("height", "auto");
							var top = "-" + (($img.height() - $imgParent.height()) / 2) + "px";
							$img.css("top", top);
					}*/



				}
			//}
			$img.css('opacity', 0).animate({opacity : 1, visibility : 'visible'}, 0.5)

			return this
		},









		/*
		 * This function initiates the hotel booking.
		 * This has been moved to utils as it is used in hotel info modal window
		 */
		postHotelForm : function(hotelId, tripAdviseRating, bookingCode, roomTypeCode, toBook, dataItem, featuredRank, uiRank, uiRankType) {
			var form = $("#ResultContainer_"+CT.settings.currentTab).find("#FormFields").get(0);
			var searchParams = _.deserialize((window.location.search != '' ? window.location.search : window.location.hash).substr(1).replace(/\+/g, ' '), ['ca1','ca2','ca3','ca4','ca5','ca6']);
			if(window.location.search != ''){
				var searchParams = _.deserialize(window.location.search.substr(1).replace(/\+/g, ' '), ['ca1','ca2','ca3','ca4','ca5','ca6']);
			}else{
				var searchParams = _.deserialize(window.location.hash.slice(window.location.hash.indexOf('?') + 1).replace(/\+/g, ' '), ['ca1','ca2','ca3','ca4','ca5','ca6']);
			}
			/*if($.browser.msie && parseInt($.browser.version, 10) <= 9) {
				var searchParams = _.deserialize(window.location.hash.slice(window.location.hash.indexOf('?') + 1).replace(/\+/g, ' '), ['ca1','ca2','ca3','ca4','ca5','ca6']);
			}else{
				var searchParams = _.deserialize(window.location.search.substr(1).replace(/\+/g, ' '), ['ca1','ca2','ca3','ca4','ca5','ca6']);
			}*/
			var childrenCount = CT.cache[CT.settings.currentTab].searchParams.all.childs;
			var adultCount = CT.cache[CT.settings.currentTab].searchParams.all.adults;
			_.each(_.keys(searchParams), function(elem, idx) {
				 if(_.contains(CT.settings[CT.app].filterParamList, elem) != true){
					if(_.isArray(searchParams[elem])) {
						_.each(searchParams[elem], function(eachElem) {
							CT.utils.addHiddenField(form, elem, eachElem,"true");
						})
					}else{
						CT.utils.addHiddenField(form, elem, searchParams[elem]);
					}
				 }
			});
			if(CT.app == 'hotel' && CT.subProd && CT.subProd == 'wg' && dataItem.city){
				CT.utils.addHiddenField(form, "city", dataItem.city);
			}
			if(dataItem.fc){
				CT.utils.addHiddenField(form, "fc", Number(dataItem.fc));
			}
			CT.utils.addHiddenField(form, "featuredRank", featuredRank);
			if(dataItem.companyId) {
				CT.utils.addHiddenField(form, "companyId", dataItem.companyId);
			}
			CT.utils.addHiddenField(form, "uiRank", uiRank);
			CT.utils.addHiddenField(form, "uiRankType", uiRankType);
			CT.utils.addHiddenField(form, "num_children", childrenCount);
			CT.utils.addHiddenField(form, "num_adults", adultCount);
			CT.utils.addHiddenField(form, "star_rating", tripAdviseRating);
			CT.utils.addHiddenField(form, ( (window.productCode == "CP" || window.productCode == "AG") ? "hotelId" : "hotelid"), hotelId);//
			CT.utils.addHiddenField(form, "bookingCode", bookingCode + "|si-" + CT.cache[CT.settings.currentTab].sid);
			CT.utils.addHiddenField(form, ( (window.productCode == "CP" || window.productCode == "AG") ? "roomTypeCode" : "roomtypecode"), roomTypeCode);
			CT.utils.addHiddenField(form, "topLevelRateRules", window.topLevelRateRules);
			if(CT.app == 'hotel') {
				if(window.product !='B2B'){
					CT.utils.addHiddenField(form, "sct", window.countryCode.toUpperCase());
					CT.utils.addHiddenField(form, "scr", window.sell_currency.code.toUpperCase());
				}
				if(window.isMobileUA && window.isMobileUA == true){
					CT.utils.addHiddenField(form, "mobile_src", "MOBILE");
				}
			}
			
			if(CT.cache[CT.settings.currentTab].searchParams.all && CT.cache[CT.settings.currentTab].searchParams.all.ref){
				CT.utils.addHiddenField(form, "taRefId", CT.cache[CT.settings.currentTab].searchParams.all.ref);
			}
			
			if(dataItem.emi) {
				CT.utils.addHiddenField(form, "emiJson", dataItem.emi);
			}
			if(window.productCode == "CP" || window.productCode == "AG"){
				if(dataItem.priceInfo.pvs) {
					CT.utils.addHiddenField(form, "policyViolation", dataItem.priceInfo.pvs[0].rsid);
				}
				CT.utils.addHiddenField(form, "hotelName", (dataItem.nm)?dataItem.nm:"");
				CT.utils.addHiddenField(form, "address", (dataItem.ad)?dataItem.ad:"");
				CT.utils.addHiddenField(form, "phone", (dataItem.ph)?dataItem.ph:"");		//These fields should be
				CT.utils.addHiddenField(form, "fax", (dataItem.fx)?dataItem.fx:"");			//Removed asap
				CT.utils.addHiddenField(form, "email", (dataItem.em)?dataItem.em:"");
				CT.utils.addHiddenField(form, "webSite", (dataItem.site)?dataItem.site:"");
				CT.utils.addHiddenField(form, "area", (dataItem.ar)?dataItem.ar:"");
				CT.utils.addHiddenField(form, "rating", (dataItem.sr || dataItem.sr == 0)?dataItem.sr:"");
				CT.utils.addHiddenField(form, "amenities", (dataItem.am)?dataItem.am:"");
				
				var i = 0, rmItem = null;
				var cpRms = dataItem.priceInfo.rms
				if(cpRms){
					while (i < cpRms.length) {
						if ((cpRms[i].rtc)  === bookingCode && cpRms[i].rmtc === roomTypeCode) {
							rmItem = cpRms[i];
							break;
						}
						i++;
					}
				}
				CT.utils.addHiddenField(form, "roomType", (rmItem.rm != null ? rmItem.rm : 0));
				CT.utils.addHiddenField(form, "totalBase", (rmItem.b != null ? rmItem.b : 0));
				CT.utils.addHiddenField(form, "totalTax", (rmItem.ttd != null ? rmItem.ttd : 0));
				CT.utils.addHiddenField(form, "totalDiscount", (rmItem.d != null ? rmItem.d : 0));
				CT.utils.addHiddenField(form, "totalMkp", (rmItem.k != null ? rmItem.k : 0));
				CT.utils.addHiddenField(form, "totalFee", (rmItem.f != null ? rmItem.f : 0));
				CT.utils.addHiddenField(form, "totalPrice", (rmItem.tot != null ? rmItem.tot : 0));
				CT.utils.addHiddenField(form, "averageTax", (rmItem.t != null ? rmItem.t : 0));
				CT.utils.addHiddenField(form, "totalServiceTax", (rmItem.tst != null ? rmItem.tst : 0));
				CT.utils.addHiddenField(form, "averagePrice", (rmItem.avg != null ? rmItem.avg : 0));
				CT.utils.addHiddenField(form, "postPay", (rmItem.pp != null ? rmItem.pp : 0));
				
				CT.utils.addHiddenField(form, "inclusions", rmItem.i);
				
				if(window.productCode == "AG"){
					CT.utils.addHiddenField(form, "agencyServiceFee", (rmItem.agm != null ? rmItem.agm : 0));
					CT.utils.addHiddenField(form, "agencyCommission", (rmItem.agc != null ? rmItem.agc : 0));
					CT.utils.addHiddenField(form, "agencyCommissionTax", (rmItem.agt != null ? rmItem.agt : 0));
				}
				
				
				
			}

			if (!$(form).hasClass("no-action-change")) {
				if (toBook) {
					var pHttps = window.pHttps;
					if (pHttps == undefined || pHttps == null)
						pHttps = "https";
					if (window["productCode"]) {
						form.action = pHttps + "://" + location.host + "/hotelBook";
					} else {
						form.action = pHttps + "://" + location.host + "/hotels/multistep";
					}
				} else {
					form.action = "/hotels/info/" + hotelId;
				}
			}
			var rank = CT.masterJson.getHotel(hotelId).p, 
			    label = CT.cache[CT.settings.currentTab].paramsForGA,
			    action = arguments[arguments.length - 2] === 'H_Modal_Book' ? 'H_Modal_Book' : 'H_Details_Book',
			    roomindex = arguments[arguments.length - 1];
			if(action === 'H_Details_Book')
			    label += "&rank=" + rank;
			else if(action === 'H_Modal_Book')
			    label = 'hotelid=' + hotelId + '&rank=' + rank + '&roomindex=' + roomindex
			var category = CT.subProd == undefined? (window.twoCol == true ? 'Hotels_TR_2col' : 'Hotels_TR') : 'Hotels_GR'
			CT.utils.helperFunctions.trackGAEventWrapper(category, action, label, '100');
			var priceDispShown = CT.utils.cookies.read("prDispUnitEle") ? CT.utils.cookies.read("prDispUnitEle") : "";
			CT.utils.helperFunctions.trackGAEventWrapper("Hotels_TR", "H_PriceShown"+priceDispShown, label, '100');
			
			if(window.isHttpsEnabled) // For agency and corp
				$(form).prop('action',$(form).prop('action').replace('http://','https://'));
			
			form.submit();
			return false;
		},


		










		/*
		 * @DESC : update trust hotels with more room rates
		 *			this is a common function among modal window and srp page
		 * @PARAM : hotelObj - is an optional parameter
		 */
		updateTrustHotelRoomRates: function(hotelId, hotelObj, callback) {
			var searchParams, tmp = CT.cache[CT.settings.currentTab].searchParams;

			hotelObj = hotelObj || CT.masterJson.getHotel(hotelId);

			if(hotelObj.priceInfo && hotelObj.priceInfo.tc == 1 && hotelObj.priceInfo.rms && hotelObj.priceInfo.rms.length == 1) {
				searchParams = $.extend(true, tmp.all, tmp.defaults);
				if(hotelObj.companyId){
					searchParams.companyId = hotelObj.companyId;
				}
				if(searchParams.ct_hotelid != null && searchParams.ct_hotelid === ""){
					delete searchParams.ct_hotelid;
				}
				url = CT.to_html(CT.settings[CT.app].urls[CT.app == 'dp' ? "dpTrust" : "trust"], { pm: _.serialize(searchParams), hotelId: hotelId });
				url += '&tux=1';
				$.ajax({
					url: url,
					beforeSend: function( xhr ) {
                    	if(window.productCode == "CP" || window.productCode == "AG"){
                    		xhr.setRequestHeader( "X-CT-SOURCETYPE", window.productCode == "CP" ? "CORP" : "AGENCY");
                    	}
					},
					success: function(respJson) {
						if(CT.app == 'dp'){
							hotelObj.priceInfo.rms = respJson.rr[hotelObj.id].rms;
							hotelObj.pf = respJson.rr[hotelObj.id].pf;
							hotelObj.ps = respJson.rr[hotelObj.id].ps;
							callback(hotelObj);
						}else{
							//update hotelObj here
							if(respJson.img)
								hotelObj.img = respJson.img;
							if(hotelObj.pp){
								hotelObj.priceInfo.rms = [];
							}
							// Author: Bhimsen S K.
							// removing the old info as it contains redundant data.
							hotelObj.priceInfo.rms = [];
							_.each(respJson.rms, function(rms) {
								hotelObj.priceInfo.rms.push(rms);

							});
							callback(hotelObj);
						}
					},
					error: function(respJson) {
						L('trust ajax call failed');
					}
				});
			}
		},
		


ASLogger: (function(){

			var tc, ts, s, d=0, c, t, p=1;

			function makeJSON(){

				var lObj = {};

				lObj.tc = String(tc);
				lObj.ts = String(ts);
				lObj.s = s;
				lObj.p = String(p);
				lObj.c = String(c);
				lObj.d = String(d);
				lObj.ty = t;

				return lObj;



			}

			function setTime(time){

				tc = time;
			}


			function logToServer(){

				var lObj = makeJSON();

				$.ajax({ url : 'lhs', data : lObj, type: "POST" }).done(function(){

				});



			}

			function setTS(st){

				ts = st;

			}

			function setS(_s){

				s = _s;
				d = 0;
			}

			function setD(){

				d = 1;
			}

			function setResults(l){

				c = l;
			}

			function setType(_t){

				t = _t;
			}


			return {

				logToServer : logToServer,
				setTime : setTime,
				setTS : setTS,
				setS : setS,
				setD : setD,
				setResults : setResults,
				setType : setType

			}


		})()



	})
})
;
